var map = {
	"./Footer": 4371,
	"./Footer.jsx": 4371,
	"./Header": 9409,
	"./Header.jsx": 9409,
	"./ImageLoader": 9270,
	"./ImageLoader.jsx": 9270,
	"./dashboard-header": 1178,
	"./dashboard-header.jsx": 1178,
	"./global": 1597,
	"./global.js": 1597,
	"./global.jsx": 1263,
	"./stripeCheckout": 9771,
	"./stripeCheckout.js": 9771,
	"./testimonialSlider": 6500,
	"./testimonialSlider.jsx": 6500,
	"./useDocumentTitle": 922,
	"./useDocumentTitle.jsx": 922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8720;